export const baseRoutes = {
  userBaseRoutes: "",
};